var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGok2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 223,
    viewBox: "0 0 179 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9297 207.567V189.519L69.5674 204.898V222.946L42.9297 207.567Z",
    fill: "#6580E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9266 189.519L27.2969 198.543L53.9346 213.922L69.5644 204.898L42.9266 189.519Z",
    fill: "#6580E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2969 198.543V180.495L53.9346 195.874V213.922L27.2969 198.543Z",
    fill: "#301305"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3016 180.495L11.6719 189.519L38.3096 204.898L53.9394 195.874L27.3016 180.495Z",
    fill: "#301305"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6719 189.519V99.2806L38.3096 114.66V204.898L11.6719 189.519Z",
    fill: "#301305"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6719 99.2806L27.3016 90.2568L53.9394 105.636L38.3096 114.66L11.6719 99.2806Z",
    fill: "#6580E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2969 90.2568V72.2091L53.9346 87.5885V105.636L27.2969 90.2568Z",
    fill: "#6580E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2969 72.2091L42.9266 63.1852L69.5644 78.5645L53.9346 87.5884L27.2969 72.2091Z",
    fill: "#6580E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9297 63.1853V45.1376L69.5674 60.5169V78.5646L42.9297 63.1853Z",
    fill: "#6580E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9297 45.1377L121.078 0.0185051L147.716 15.3978L69.5674 60.517L42.9297 45.1377Z",
    fill: "#6580E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.078 0.0184669V18.0661L147.716 33.4454V15.3978L121.078 0.0184669Z",
    fill: "#572811"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.078 18.0661L136.708 9.0423L163.346 24.4216L147.716 33.4454L121.078 18.0661Z",
    fill: "#6580E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.711 9.04227V27.0899L163.349 42.4692V24.4216L136.711 9.04227Z",
    fill: "#572811"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.711 27.0899L152.341 18.0661L178.978 33.4454L163.349 42.4692L136.711 27.0899Z",
    fill: "#6580E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.336 18.0662V108.305L178.974 123.684V33.4455L152.336 18.0662Z",
    fill: "#572811"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.341 108.305L136.711 117.328L163.349 132.708L178.978 123.684L152.341 108.305Z",
    fill: "#301305"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.711 117.328V135.376L163.349 150.755V132.708L136.711 117.328Z",
    fill: "#572811"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.708 135.376L121.078 144.4L147.716 159.779L163.346 150.755L136.708 135.376Z",
    fill: "#301305"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.078 144.4V162.447L147.716 177.827V159.779L121.078 144.4Z",
    fill: "#572811"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.078 162.447L42.9297 207.567L69.5674 222.946L147.716 177.827L121.078 162.447Z",
    fill: "#301305"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9297 207.567L69.5674 222.946L42.9297 207.567Z",
    fill: "#6580E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9313 207.567V189.519L27.3016 198.543V180.495L11.6719 189.519V99.2807L27.3016 90.2569V72.2092L42.9313 63.1854V45.1377L121.08 0.0185699V18.0662L136.71 9.04239V27.0901L152.339 18.0662V108.305L136.71 117.328V135.376L121.08 144.4V162.448L42.9313 207.567Z",
    fill: "url(#paint0_linear_6318_31733)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6318_31733)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9313 207.567V189.519L27.3016 198.543V180.495L11.6719 189.519V99.2807L27.3016 90.2569V72.2092L42.9313 63.1854V45.1377L121.08 0.0185699V18.0662L136.71 9.04239V27.0901L152.339 18.0662V108.305L136.71 117.328V135.376L121.08 144.4V162.448L42.9313 207.567Z",
    fill: "url(#paint1_linear_6318_31733)",
    fillOpacity: 0.26
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3359 84.4241L113.225 46.3832L120.284 50.459L54.3955 88.4999L47.3359 84.4241Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.214 46.3837L113.214 84.4247L120.274 88.5005L120.274 50.4595L113.214 46.3837Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.219 84.4242L129.691 74.9139L136.751 78.9898L120.278 88.5L113.219 84.4242Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.691 74.9145L129.691 112.955L136.75 117.031L136.75 78.9903L129.691 74.9145Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3316 160.507L47.3316 122.466L54.3911 126.541L54.3911 164.582L47.3316 160.507Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3316 122.465L30.8594 131.975L37.9189 136.051L54.3911 126.541L47.3316 122.465Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.861 131.975L30.861 112.955L37.9205 117.031L37.9205 136.051L30.861 131.975Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8594 112.955L47.3316 103.445L54.3911 107.521L37.9189 117.031L30.8594 112.955Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3298 103.445L47.3298 84.4247L54.3893 88.5005L54.3893 107.521L47.3298 103.445Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3359 84.4241L54.3957 88.5L47.3359 84.4241Z",
    fill: "#572811"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3359 84.4241V84.4241ZM47.3359 84.4241L54.3957 88.5M54.3957 88.5V88.5Z",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.697 112.955L47.3359 160.506L54.3955 164.582L136.756 117.031L129.697 112.955Z",
    fill: "#301305",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3271 84.4246L113.216 46.3837L113.216 84.4246L129.688 74.9144L129.688 112.955L47.3272 160.506L47.3271 122.465L30.8549 131.976L30.8549 112.955L47.3272 103.445L47.3271 84.4246Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2812 80.3496L106.17 42.3087L113.229 46.3845L47.3408 84.4254L40.2812 80.3496Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.16 42.3091L106.16 80.3501L113.219 84.4259L113.219 46.3849L106.16 42.3091Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.164 80.3495L122.636 70.8392L129.696 74.915L113.224 84.4253L106.164 80.3495Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.636 70.84L122.636 108.881L129.696 112.957L129.696 74.9158L122.636 70.84Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2769 156.432L40.2769 118.391L47.3364 122.467L47.3364 160.508L40.2769 156.432Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8063 127.901L23.8063 108.881L30.8658 112.956L30.8658 131.977L23.8063 127.901Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8047 108.881L40.2769 99.3702L47.3364 103.446L30.8642 112.956L23.8047 108.881Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2751 99.3704L40.2751 80.3502L47.3346 84.426L47.3346 103.446L40.2751 99.3704Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2812 80.3496L47.341 84.4255L40.2812 80.3496Z",
    fill: "#572811"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2812 80.3496V80.3496ZM40.2812 80.3496L47.341 84.4255M47.341 84.4255V84.4255Z",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2769 118.391L23.8047 127.901L30.8642 131.977L47.3364 122.466L40.2769 118.391Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.642 108.88L40.2812 156.431L47.3408 160.507L129.702 112.956L122.642 108.88Z",
    fill: "#301305",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2803 80.3499L106.169 42.309L106.169 80.3499L122.641 70.8397L122.641 108.881L40.2803 156.432L40.2803 118.391L23.8081 127.901L23.8081 108.881L40.2803 99.3701L40.2803 80.3499Z",
    fill: "#CA9660"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0762 38.2476L33.1875 76.2885L40.247 80.3643L106.136 42.3234L99.0762 38.2476Z",
    fill: "#793D20",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0798 57.2679L99.0798 38.2476L106.139 42.3234L106.139 61.3437L99.0798 57.2679Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.197 76.2878L33.197 95.3081L40.2565 99.3839L40.2565 80.3636L33.197 76.2878Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1875 95.3088L33.2109 95.2953L40.2706 99.3712L40.2472 99.3848L33.1875 95.3088Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2161 95.295L33.2161 152.356L40.2756 156.432L40.2756 99.3708L33.2161 95.295Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2109 152.357L49.683 142.847L56.7425 146.922L40.2705 156.433L33.2109 152.357Z",
    fill: "#301305",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6849 142.846L49.6849 85.7846L56.7444 89.8604L56.7444 146.922L49.6849 142.846Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6875 85.7849L99.0807 57.2677L106.14 61.3435L56.747 89.8607L49.6875 85.7849Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0859 57.2676L106.146 61.3435L99.0859 57.2676Z",
    fill: "#572811"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0859 57.2676V57.2676ZM99.0859 57.2676L106.146 61.3435M106.146 61.3435V61.3435Z",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0792 57.2678L99.0792 38.2475L33.1905 76.2883L33.1905 95.3086L33.2139 95.2951L33.2139 152.357L49.6859 142.846L49.6859 85.785L99.0792 57.2678Z",
    fill: "#793D20",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1518 95.295L49.6797 104.805L56.7392 108.881L73.2113 99.3708L66.1518 95.295Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6813 104.805L49.6813 123.825L56.7409 127.901L56.7409 108.881L49.6813 104.805Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6797 123.825L66.1518 114.315L73.2113 118.39L56.7392 127.901L49.6797 123.825Z",
    fill: "#EEEEEE",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1501 114.315L66.1501 95.2945L73.2096 99.3703L73.2096 118.391L66.1501 114.315Z",
    fill: "white",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1484 95.2955L73.2082 99.3715L66.1484 95.2955Z",
    fill: "#572811"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1484 95.2955V95.2955ZM66.1484 95.2955L73.2082 99.3715M73.2082 99.3715V99.3715Z",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0971 76.2744L82.625 85.7845L89.6845 89.8604L106.157 80.3502L99.0971 76.2744Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6267 85.7851L82.6267 104.805L89.6862 108.881L89.6862 89.8609L82.6267 85.7851Z",
    fill: "#572811",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.625 104.805L99.0971 95.2953L106.157 99.3711L89.6845 108.881L82.625 104.805Z",
    fill: "#EEEEEE",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0954 95.2946L99.0954 76.2743L106.155 80.3501L106.155 99.3704L99.0954 95.2946Z",
    fill: "white",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1016 76.2744L106.161 80.3503L99.1016 76.2744Z",
    fill: "#572811"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1016 76.2744V76.2744ZM99.1016 76.2744L106.161 80.3503M106.161 80.3503V80.3503Z",
    stroke: "#FC8B84",
    strokeWidth: 0.244549,
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1534 95.2951L49.6813 104.805L49.6813 123.826L66.1534 114.315L66.1534 95.2951ZM99.0978 76.2746L82.6258 85.7847L82.6258 104.805L99.0978 95.2949L99.0978 76.2746Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6318_31733",
    x: 11.6719,
    y: 0.0185547,
    width: 143.125,
    height: 210.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.53517,
    dy: 14.149
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6318_31733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6318_31733",
    x1: 82.0057,
    y1: 207.567,
    x2: 82.0057,
    y2: 0.0185699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6318_31733",
    x1: 82.0057,
    y1: 207.567,
    x2: 82.0057,
    y2: 0.0185699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGok2);
export default __webpack_public_path__ + "static/media/gok-2.04be388f10c2c464951dbdaf4373e983.svg";
export { ForwardRef as ReactComponent };